import React from 'react'

const RenewIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M2.55 8.025C2.36667 7.70833 2.22917 7.38333 2.1375 7.05C2.04583 6.71667 2 6.375 2 6.025C2 4.90833 2.3875 3.95833 3.1625 3.175C3.9375 2.39167 4.88333 2 6 2H6.0875L5.2875 1.2L5.9875 0.5L7.9875 2.5L5.9875 4.5L5.2875 3.8L6.0875 3H6C5.16667 3 4.45833 3.29375 3.875 3.88125C3.29167 4.46875 3 5.18333 3 6.025C3 6.24167 3.025 6.45417 3.075 6.6625C3.125 6.87083 3.2 7.075 3.3 7.275L2.55 8.025ZM6.0125 11.5L4.0125 9.5L6.0125 7.5L6.7125 8.2L5.9125 9H6C6.83333 9 7.54167 8.70625 8.125 8.11875C8.70833 7.53125 9 6.81667 9 5.975C9 5.75833 8.975 5.54583 8.925 5.3375C8.875 5.12917 8.8 4.925 8.7 4.725L9.45 3.975C9.63333 4.29167 9.77083 4.61667 9.8625 4.95C9.95417 5.28333 10 5.625 10 5.975C10 7.09167 9.6125 8.04167 8.8375 8.825C8.0625 9.60833 7.11667 10 6 10H5.9125L6.7125 10.8L6.0125 11.5Z'
      fill='#707885'
    />
  </svg>
)

export default RenewIcon
